import axios from "axios";
import { HEADERS } from "../../../../API/UrlAndPaths";
import store from "../../../../Redux/store";
import { setPosReceiptSlice } from "./posReceiptSlice";
import { setErrorSnack, setSnackMsg, setSuccessSnack } from "../../Sales/Billing/Slice/billingScreenSlice";
import { setSubmitLoading } from "../../../../Redux/Dashboard/mainDashBoardSlice";

const extractTemplate = (value) => {
  console.log('🔍 extractTemplate input:', value);
  if (value === null || value === undefined) return null;

  if (Array.isArray(value)) {
    for (const item of value) {
      const extracted = extractTemplate(item);
      if (extracted) return extracted;
    }
    return null;
  }

  if (typeof value === "number" && !Number.isNaN(value)) {
    const result = { posReceiptTemplate: value };
    console.log('🔍 extractTemplate found number:', result);
    return result;
  }

  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    if (!Number.isNaN(parsed)) {
      const result = { posReceiptTemplate: parsed };
      console.log('🔍 extractTemplate found string:', result);
      return result;
    }
  }

  if (typeof value === "object") {
    if (
      "posReceiptTemplate" in value &&
      value.posReceiptTemplate !== undefined &&
      value.posReceiptTemplate !== null
    ) {
      const result = {
        posReceiptTemplate: Number(value.posReceiptTemplate) || value.posReceiptTemplate,
      };
      console.log('🔍 extractTemplate found posReceiptTemplate:', result);
      return result;
    }
    if (
      "posTemplateSelected" in value &&
      value.posTemplateSelected !== undefined &&
      value.posTemplateSelected !== null
    ) {
      const nested = extractTemplate(value.posTemplateSelected);
      if (nested) return nested;
      const result = {
        posReceiptTemplate: Number(value.posTemplateSelected) || value.posTemplateSelected,
      };
      console.log('🔍 extractTemplate found posTemplateSelected:', result);
      return result;
    }
    if (
      "template" in value &&
      value.template !== undefined &&
      value.template !== null
    ) {
      const result = { posReceiptTemplate: Number(value.template) || value.template };
      console.log('🔍 extractTemplate found template:', result);
      return result;
    }
    if ("posReceiptTemplateModel" in value) {
      return extractTemplate(value.posReceiptTemplateModel);
    }

    for (const nestedValue of Object.values(value)) {
      const nested = extractTemplate(nestedValue);
      if (nested) return nested;
    }
  }

  console.log('🔍 extractTemplate found nothing');
  return null;
};

const normalizeTemplateResponse = (responseData) => {
  console.log('🔍 normalizeTemplateResponse input:', responseData);
  if (!responseData) return null;

  const candidates = [
    responseData,
    responseData?.data,
    responseData?.result,
    responseData?.data?.data,
    responseData?.data?.result,
    responseData?.result?.data,
    responseData?.result?.result,
  ];

  for (const candidate of candidates) {
    const extracted = extractTemplate(candidate);
    if (extracted) {
      console.log('🔍 normalizeTemplateResponse found in candidates:', extracted);
      return extracted;
    }
  }

  console.log('🔍 normalizeTemplateResponse found nothing');
  return null;
};

//get select template info
export const getTemplateInfoAPI = async (forceRefresh = false) => {
  try {
    // Add cache-busting header to bypass offline cache
    const headers = forceRefresh 
      ? { ...HEADERS, headers: { ...HEADERS.headers, 'x-skip-cache': 'true', 'Cache-Control': 'no-cache' } }
      : HEADERS;
    
    const result = await axios.post(
      "admin/getPosReceiptTemplateModel",
      {},
      headers
    );
    console.log('🔍 getTemplateInfoAPI response:', result.data);
    if (result.status === 200) {
      const payload = normalizeTemplateResponse(result?.data);
      console.log('🔍 getTemplateInfoAPI normalized payload:', payload);
      
      // Check localStorage first (unless force refresh)
      const localTemplate = localStorage.getItem('posReceiptTemplate');
      console.log('🔍 localStorage template:', localTemplate, 'forceRefresh:', forceRefresh);
      
      let finalPayload = payload;
      
      if (forceRefresh) {
        // Force refresh: Always use API response and save to localStorage
        if (payload?.posReceiptTemplate !== undefined && payload?.posReceiptTemplate !== null) {
          localStorage.setItem('posReceiptTemplate', payload.posReceiptTemplate.toString());
          console.log('🔍 FORCE REFRESH: Saved API template to localStorage:', payload.posReceiptTemplate);
          finalPayload = payload;
        }
      } else if (localTemplate) {
        console.log('🔍 Using localStorage template as priority:', localTemplate);
        finalPayload = { posReceiptTemplate: Number(localTemplate) };
      } else if (payload?.posReceiptTemplate !== undefined && payload?.posReceiptTemplate !== null) {
        // Save API response to localStorage for future use
        localStorage.setItem('posReceiptTemplate', payload.posReceiptTemplate.toString());
        console.log('🔍 Saved API template to localStorage:', payload.posReceiptTemplate);
      }
      
      console.log('🔍 getTemplateInfoAPI dispatching to Redux:', finalPayload);
      store.dispatch(setPosReceiptSlice(finalPayload));
    }
  } catch (error) {
    console.log('🔍 getTemplateInfoAPI error:', error);
    store.dispatch(setPosReceiptSlice(null));

    console.log(error);
  }
};
//post  select pos receipt template data to server
export const setPosReceiptTemplateAPI = async (data) => {
  console.log('🔍 setPosReceiptTemplateAPI called with:', data);
  store.dispatch(setSubmitLoading(true));
  
  // IMMEDIATELY save to localStorage from the request body (most reliable source)
  const requestTemplate = data?.body?.posReceiptTemplate;
  if (requestTemplate !== undefined && requestTemplate !== null) {
    localStorage.setItem('posReceiptTemplate', requestTemplate.toString());
    console.log('🔍 IMMEDIATELY saved template to localStorage from request:', requestTemplate);
    // Also immediately update Redux
    store.dispatch(setPosReceiptSlice({ posReceiptTemplate: Number(requestTemplate) }));
  }
  
  try {
    const result = await axios.post(
      "admin/setPosReceiptTemplateModel",
      data.body,
      HEADERS
    );
    console.log('🔍 setPosReceiptTemplateAPI response:', result.data);
    if (result.status === 200) {
      const payload = normalizeTemplateResponse(result?.data);
      console.log('🔍 setPosReceiptTemplateAPI normalized payload:', payload);
      const fallbackPayload = extractTemplate(data?.body);
      console.log('🔍 setPosReceiptTemplateAPI fallback from body:', fallbackPayload);
      const resolvedPayload =
        payload ?? fallbackPayload ?? (data?.body?.posReceiptTemplate !== undefined
          ? { posReceiptTemplate: data.body.posReceiptTemplate }
          : null);
      console.log('🔍 setPosReceiptTemplateAPI final resolved payload:', resolvedPayload);
      if (resolvedPayload?.posReceiptTemplate !== undefined && resolvedPayload?.posReceiptTemplate !== null) {
        // Confirm save to localStorage (may already be saved above)
        localStorage.setItem('posReceiptTemplate', resolvedPayload.posReceiptTemplate.toString());
        console.log('🔍 Confirmed template in localStorage:', resolvedPayload.posReceiptTemplate);
        
        store.dispatch(setSnackMsg(`Changed to Template ${resolvedPayload.posReceiptTemplate}`));
        store.dispatch(setSuccessSnack(true));
      }
      console.log('🔍 setPosReceiptTemplateAPI dispatching to Redux:', resolvedPayload);
      store.dispatch(setPosReceiptSlice(resolvedPayload));
    }
  } catch (error) {
    console.log('🔍 setPosReceiptTemplateAPI error:', error);
    store.dispatch(
      setSnackMsg(
        error?.response?.status === 500
          ? "Internal server error !!"
          : error?.response?.data
      )
    );
    store.dispatch(setErrorSnack(true));
  } finally {
    store.dispatch(setSubmitLoading(false));
  }
};
